import { CreditCard as CreditCardIcon } from "@phosphor-icons/react";

export default CreditCardIcon
